var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.41797C8.12763 7.41797 7.41797 8.12763 7.41797 9C7.41797 9.87237 8.12763 10.582 9 10.582C9.87237 10.582 10.582 9.87237 10.582 9C10.582 8.12763 9.87237 7.41797 9 7.41797Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.05668 0 0 4.05668 0 9C0 13.9433 4.05668 18 9 18C13.9433 18 18 13.9433 18 9C18 4.05668 13.9433 0 9 0ZM14.8008 9.52734C14.8008 10.6907 13.8548 11.6367 12.6914 11.6367C11.9787 11.6367 11.3501 11.2795 10.9682 10.7369C10.4846 11.2841 9.78588 11.6367 9 11.6367C7.54618 11.6367 6.36328 10.4538 6.36328 9C6.36328 7.54618 7.54618 6.36328 9 6.36328C9.59583 6.36328 10.14 6.56947 10.582 6.90409V6.89062H11.6367V9C11.6367 9.18056 11.6181 9.35687 11.5834 9.52734H11.6367C11.6367 10.1088 12.11 10.582 12.6914 10.582C13.2728 10.582 13.7461 10.1088 13.7461 9.52734V9C13.7461 6.38286 11.6171 4.25391 9 4.25391C6.38286 4.25391 4.25391 6.38286 4.25391 9C4.25391 11.6171 6.38286 13.7461 9 13.7461C10.0547 13.7461 11.0522 13.4083 11.885 12.7686L12.5276 13.605C11.5085 14.3872 10.289 14.8008 9 14.8008C5.80145 14.8008 3.19922 12.1986 3.19922 9C3.19922 5.80145 5.80145 3.19922 9 3.19922C12.1986 3.19922 14.8008 5.80145 14.8008 9V9.52734Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_136",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.0dba48cd0a25d54695dfda8c7caba957.svg";
export { ForwardRef as ReactComponent };